import { Fragment } from 'react';
import { getMeta } from 'constants/meta';
import Head from 'components/Head';

const Terms = ({ location }) => {
  const { title, description } = getMeta(location.pathname);
  return (
    <Fragment>
      <Head title={title} description={description} />
      <section className="section section_terms">
        <div className="wrapper">
          <div className="row">
            <div className="col col-10 offset-1 col-tablet-12 offset-tablet-0">
              <div className="section__header-wrap _mb-66 _mb-phone-36">
                <h2 className="title title_size_m _mb-18 section__main-title _mb-phone-10">
                  Terms and conditions of service
                </h2>
                <p className="text section__sub-text">
                  Last modified: 2 January 2019
                </p>
              </div>
              <div>
                <h5 className="title section__title _mb-17">1. Introduction</h5>
                <p className="text section__text _mb-13">
                  Please read these terms and conditions carefully. By using our
                  website (the "
                  <strong className="text__strong">Siteplus Site</strong>
                  "), you accept these terms and conditions in full;
                  accordingly, if you disagree with these terms and conditions,
                  you must not use the Siteplus Site.
                </p>
                <p className="text section__text _mb-13">
                  In addition, contracts that we may enter into from time to
                  time for the provision of our cloud-based website builder
                  services, hosting services, managed website builder services
                  and other services (collectively, the "
                  <strong className="text__strong">Services</strong>
                  ") shall be governed by these terms and conditions, and we
                  will ask for your express acceptance of these terms and
                  conditions before providing the Services to you.
                </p>
                <p className="text section__text _mb-23">
                  These terms and conditions apply to websites that are created
                  using your account on the Siteplus Site ("
                  <strong className="text__strong">Your Sites</strong>
                  "), and to all data, works and materials that you upload or
                  submit to the Siteplus Site or Services, including data,
                  images, videos, photographs and other works and materials
                  stored in the database for Your Sites (but excluding for the
                  avoidance of doubt log files relating to Your Sites and any
                  survey data that we may collect from time to time) ("
                  <strong className="text__strong">Your Data</strong>
                  "). Save to the extent that we agree otherwise in writing,
                  these terms and conditions may also apply to contracts with
                  our resellers ("
                  <strong className="text__strong">Resellers</strong>
                  ").
                </p>
                <h5 className="title section__title _mb-17">
                  2. Contractual relationship
                </h5>
                <p className="text section__text _mb-13">
                  ‌References in these terms and conditions to "we", "us" or
                  "our" are to Siteplus Pte Ltd. For full details of our
                  company, see Section 30.
                </p>
                <p className="text section__text _mb-13">
                  References in these terms and conditions to "you" or "your"
                  are to the individual who uses or creates an account ("
                  <strong className="text__strong">Account</strong>
                  ") on the Siteplus Site, subject to the following paragraph.
                </p>
                <p className="text section__text _mb-23">
                  If you identify a limited liability company or other legal
                  entity in your Account information, and you have actual or
                  ostensible authority to bind that legal entity to a contract
                  under these terms and conditions, then these terms and
                  conditions will also bind that entity. In these circumstances,
                  references to "you" or "your" are to both the individual user
                  and the relevant legal entity (unless the context requires
                  otherwise).
                </p>
                <h5 className="title section__title _mb-17">
                  3. Copyright notice
                </h5>
                <p className="text section__text _mb-13">
                  Copyright (c) 2025 Siteplus Pte Ltd.
                </p>
                <p className="text section__text _mb-23">
                  Subject to the express provisions of these terms and
                  conditions: (a) we, together with our licensors, own and
                  control all the copyright and other intellectual property
                  rights in the Siteplus Site and Services; and (b) all the
                  copyright and other intellectual property rights in the
                  Siteplus Site and Services are reserved.
                </p>
                <h5 className="title section__title _mb-17">
                  4. Your rights to use the Siteplus Site
                </h5>
                <p className="text section__text _mb-13">
                  You may: (a) view pages from the Siteplus Site in a web
                  browser; (b) download pages from the Siteplus Site for caching
                  in a web browser; and (c) stream audio and video files from
                  the Siteplus Site, subject in each case to the other
                  provisions of these terms and conditions, and providing that
                  your rights to use the Services are as set out in Section 9.
                </p>
                <p className="text section__text _mb-13">
                  Except as expressly permitted by these terms and conditions,
                  you must not download any material from the Siteplus Site or
                  save any such material to your computer.
                </p>
                <p className="text section__text _mb-13">
                  Unless you own or control the relevant rights in the material,
                  you must not:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    republish material from the Siteplus Site (including
                    republication on another website);
                  </li>
                  <li className="text list__item section__text _mb-7">
                    sell, rent or sub-license material from the Siteplus Site;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    show any material from the Siteplus Site in public;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    exploit material from the Siteplus Site for a commercial
                    purpose; or
                  </li>
                  <li className="text list__item section__text">
                    redistribute material from the Siteplus Site.
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  Without prejudice to any rights you may have under any
                  subscription to the Services (a "
                  <strong className="text__strong">Subscription</strong>
                  "), we reserve the right to restrict access to areas of the
                  Siteplus Site, or indeed the whole Siteplus Site, at our
                  discretion.
                </p>
                <p className="text section__text _mb-23">
                  You must not circumvent or bypass, or attempt to circumvent or
                  bypass, any access restriction measures on the Siteplus Site.
                </p>
                <h5 className="title section__title _mb-17">
                  5. Registration and Account management
                </h5>
                <p className="text section__text _mb-13">
                  To be eligible for an Account, you must be at least 16 years
                  of age.
                </p>
                <p className="text section__text _mb-13">
                  You may register for an Account by completing and submitting
                  the Account registration form on the Siteplus Site and
                  clicking on the verification link in the email that we will
                  send to you. During the registration process, you must choose
                  either a free trial Subscription (a "
                  <strong className="text__strong">Trial Subscription</strong>
                  "), a regular paid Subscription (a "
                  <strong className="text__strong">General Subscription</strong>
                  ") or a reseller Subscription (a "
                  <strong className="text__strong">
                    Reseller Subscription
                  </strong>
                  ").
                </p>
                <p className="text section__text _mb-13">
                  You must not allow any other person to use your Account. You
                  must use reasonable endeavours, including reasonable security
                  measures relating to Account access details, to ensure that no
                  unauthorised person may gain access to the Services using your
                  Account. You must notify us in writing immediately if you
                  become aware of any unauthorised use of your Account. You must
                  not use any other person's account to access the Siteplus Site
                  or Services, unless you have that person's express permission
                  to do so. You are responsible for any unauthorised use of your
                  Account and you may be held liable for any losses arising out
                  of such use.
                </p>
                <p className="text section__text _mb-13">
                  If you register for an Account, you will be asked to choose a
                  password. You must keep your password confidential, and you
                  must notify us in writing immediately if you become aware of
                  any disclosure of your password. You are responsible for any
                  activity on the Siteplus Site arising out of any failure to
                  keep your password confidential, and you may be held liable
                  for any losses arising out of such a failure.
                </p>
                <p className="text section__text _mb-13">
                  After you have created an Account, you will be given access to
                  the account manager functionality on the Siteplus Site (the "
                  <strong className="text__strong">Account Manager</strong>
                  ").
                </p>
                <p className="text section__text _mb-13">
                  You may edit your profile information at any time using your
                  Account Manager.
                </p>
                <p className="text section__text _mb-13">
                  We may edit your Account details at any time in our sole
                  discretion.
                </p>
                <p className="text section__text _mb-23">
                  Subject to your express rights under these terms and
                  conditions with respect to a General Subscription or Reseller
                  Subscription, we may temporarily suspend your Account at any
                  time in our sole discretion.
                </p>
                <h5 className="title section__title _mb-17">
                  6. Trial Subscriptions
                </h5>
                <p className="text section__text _mb-13">
                  Trial Subscriptions shall last for the period specified during
                  registration.
                </p>
                <p className="text section__text _mb-13">
                  While participating in a Trial Subscription, you will not be
                  charged any fees until the end of the Trial Subscription
                  period, and accordingly Section 8 shall not apply with respect
                  to Trial Subscriptions.
                </p>
                <p className="text section__text _mb-13">
                  At the end of the Trial Subscription period, you will be
                  prompted to upgrade to a General Subscription.
                </p>
                <p className="text section__text _mb-23">
                  We may from time to time vary the benefits associated with a
                  Trial Subscription in our sole discretion with or without
                  notice.
                </p>
                <h5 className="title section__title _mb-17">
                  7. General Subscriptions
                </h5>
                <p className="text section__text _mb-13">
                  To become a General Subscriber, you must select the General
                  Subscription option on our website or upgrade your Trial
                  Subscription using your Account Manager, and in each case pay
                  the applicable fees.
                </p>
                <p className="text section__text _mb-13">
                  The contract under which your General Subscription is provided
                  will be in force upon the issue of an order acknowledgement
                  under this Section 7.
                </p>
                <p className="text section__text _mb-13">
                  For so long as your Account and General Subscription remain
                  active and paid up, you will have access to the Services,
                  subject to the other provisions of these terms and conditions.
                </p>
                <p className="text section__text _mb-23">
                  We may from time to time vary the benefits associated with a
                  General Subscription by giving you written notice of the
                  variation, providing that, if in our reasonable opinion such a
                  variation results in a substantial loss of value or
                  functionality, we will notify you that you have the right to
                  cancel your General Subscription, which you may exercise at
                  any time within the period of 7 days following the date of our
                  notice. If you do exercise that right, your General
                  Subscription will be cancelled from the date of variation of
                  the General Subscription benefits, and we will refund to you
                  any amounts paid to us in respect of any period of General
                  Subscription after that date. The amount of the refund will be
                  calculated by us using any reasonable methodology.
                </p>
                <h5 className="title section__title _mb-17">8. Fees</h5>
                <p className="text section__text _mb-13">
                  The fees in respect of General Subscriptions will be as set
                  out on the Siteplus Site from time to time.
                </p>
                <p className="text section__text _mb-13">
                  You are responsible for paying any taxes that apply with
                  respect to your General Subscription and/or your use of the
                  Services, other than taxes payable by us on our net income or
                  profits. All amounts stated in these terms and conditions or
                  on the Siteplus Site are, unless stated otherwise, stated
                  exclusive of applicable VAT and sales taxes, which may be
                  payable by you in addition to the stated amounts.
                </p>
                <p className="text section__text _mb-13">
                  You are also responsible for ensuring that the correct tax is
                  charged and collected, and that the correct tax-related
                  documentation is produced, with respect to any sales of
                  products or services you make through or in relation to Your
                  Sites.
                </p>
                <p className="text section__text _mb-13">
                  You must pay to us the fees in advance, in cleared funds, in
                  accordance with any instructions on the Siteplus Site, unless
                  we have agreed otherwise in writing.
                </p>
                <p className="text section__text _mb-13">
                  We may vary fees from time to time by posting new fees on the
                  Siteplus Site, but this will not affect fees for services that
                  have been previously paid.
                </p>
                <p className="text section__text _mb-13">
                  If you dispute any payment made to us, you must contact us
                  immediately and provide full details of your claim.
                </p>
                <p className="text section__text _mb-13">
                  If you make an unjustified credit card, debit card or other
                  charge-back then you will be liable to pay us, within 7 days
                  following the date of our written request:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    an amount equal to the amount of the charge-back;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    all third party expenses incurred by us in relation to the
                    charge-back (including charges made by our or your bank or
                    payment processor or card issuer);
                  </li>
                  <li className="text list__item section__text _mb-7">
                    an administration fee of USD 40.00 including VAT; and
                  </li>
                  <li className="text list__item section__text">
                    all our reasonable costs, losses and expenses incurred in
                    recovering the amounts referred to in this Section 8
                    (including without limitation legal fees and debt collection
                    fees),
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  and for the avoidance of doubt, if you fail to recognise or
                  fail to remember the source of an entry on your card statement
                  or other financial statement, and make a charge-back as a
                  result, this will constitute an unjustified charge-back for
                  the purposes of this Section 8.
                </p>
                <p className="text section__text _mb-13">
                  If you owe us any amount under or relating to these terms and
                  conditions, we may suspend or withdraw the provision of
                  services to you.
                </p>
                <p className="text section__text _mb-23">
                  We may at any time set off any amount that you owe to us
                  against any amount that we owe to you, by sending you written
                  notice of the set-off.
                </p>
                <h5 className="title section__title _mb-17">
                  9. Services, Templates and Demo Images
                </h5>
                <p className="text section__text _mb-13">
                  For the period of your Subscription only, we hereby grant to
                  you a non-exclusive right to use the Services by means of a
                  supported web browser for the purposes of creating,
                  publishing, maintaining and operating Your Sites.
                </p>
                <p className="text section__text _mb-13">
                  As a part of the Services, we may make available pre-designed
                  website templates (the "
                  <strong className="text__strong">Templates</strong>
                  "). The Templates may include HTML files and templates, CSS
                  files and/or JavaScript files. You may use any Templates that
                  we make available in conjunction with the Services to create,
                  publish, maintain and operate Your Sites.
                </p>
                <p className="text section__text _mb-13">
                  As a part of the Services, we also make available stock
                  photographs and illustrations (the "
                  <strong className="text__strong">Images</strong>
                  "). These Images may be included as an element of the
                  Templates (the "
                  <strong className="text__strong">Demo Images</strong>
                  ") or made available via our image and icon search facility
                  (the "<strong className="text__strong">Free Images</strong>
                  "). You may use the Images as digital reproductions when
                  building Your Sites by means of the Services. You may publish
                  the Free Images on Your Sites, but you must not publish the
                  Demo Images on Your Sites or otherwise. In other words, you
                  must replace or remove all Demo Images from Your Sites before
                  they are published.
                </p>
                <p className="text section__text _mb-13">
                  When your Subscription terminates, you will cease to have any
                  rights to use the Templates and Images and any element of the
                  Templates or Images.
                </p>
                <p className="text section__text _mb-21">
                  Except to the extent expressly permitted in these terms and
                  conditions or required by law on a non-excludable basis, your
                  rights under these terms and conditions are subject to the
                  limitations specified on the Siteplus Site from time to time
                  and the following prohibitions:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    you must not resell your right to access and use the
                    Templates, Images or Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    you must not sub-license your right to access and use the
                    Templates, Images or Services, save that the Templates and
                    Free Images may be sub-licensed to the extent necessary for
                    the proper use of Your Sites;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    you must not permit any unauthorised person to access or use
                    the Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    you must not republish or redistribute the Templates,
                    providing that you may publish them as an element of Your
                    Sites via the Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    you must not republish or redistribute the Demo Images, or
                    any other material from the Services (unless you own or
                    control the necessary rights in that material);
                  </li>
                  <li className="text list__item section__text _mb-7">
                    you must not make any alteration to the Services, except as
                    expressly permitted by us; and
                  </li>
                  <li className="text list__item section__text">
                    you must not conduct or request that any other person
                    conduct any load testing or penetration testing on the
                    Services.
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  If you are a General Subscriber or Reseller, we undertake to
                  you to use reasonable endeavours to maintain the availability
                  of the Services during the period of your Subscription, but we
                  do not guarantee 100% availability. In particular, the
                  Services may be unavailable during periods of scheduled or
                  unscheduled maintenance, whether conducted by us or by our
                  services providers.
                </p>
                <p className="text section__text _mb-13">
                  We provide: (a) email support to General Subscribers from
                  Monday to Friday during office hours in EET/EEST; and (b)
                  email, chat and telephone support to Resellers from Monday to
                  Friday during office hours in EET/EEST, as well as a 24-hour
                  emergency email service for Resellers. We may vary the basis
                  upon which we provide support at any time by giving to you
                  written notice of the variation. Any support that we do
                  provide will be subject to the limitations and exclusions of
                  liability set out in these terms and conditions.
                </p>
                <p className="text section__text _mb-23">
                  If we make any Services available to you which are identified
                  as "beta" or "early access" services, then: (a) the continued
                  provision of those services shall be at our sole discretion;
                  (b) those services may not be fully functional and are liable
                  to contain material bugs and errors; (c) we may decline to
                  provide specific support in relation to those services; (d) we
                  make no warranties or representations in relation to those
                  services; and (e) the use of those services is entirely at
                  your own risk.
                </p>
                <h5 className="title section__title _mb-17">
                  10. Free domain names
                </h5>
                <p className="text section__text _mb-13">
                  You can register any available Siteplus subdomain
                  (*.siteplus.com) for use in connection with Your Sites free of
                  charge.
                </p>
                <p className="text section__text _mb-13">
                  You may use each registered subdomain for so long as your
                  Subscription continues. Such subdomains may not be used
                  without an active Subscription. If your Subscription ends,
                  your subdomain may be allocated to another person.
                </p>
                <p className="text section__text _mb-23">
                  All such subdomains: (a) must comply with the acceptable use
                  rules in Section 17; and (b) are and remain our property and
                  may not be transferred or sold.
                </p>
                <h5 className="title section__title _mb-17">
                  11. Paid domain names
                </h5>
                <p className="text section__text _mb-13">
                  We will attempt to register any domain names that you order on
                  the Siteplus Site, subject to the payment of the applicable
                  fees in advance. We do not, however, guarantee that any
                  attempt to register a domain name will be successful. We will
                  notify you by email if a registration attempt is successful.
                </p>
                <p className="text section__text _mb-13">
                  All such domains must comply with the acceptable use rules in
                  Section 17.
                </p>
                <p className="text section__text _mb-13">
                  We shall have no responsibility for the maintenance of any
                  domain name after registration; it shall be your
                  responsibility to ensure that domain name registrations are
                  maintained, domain names are renewed and applicable renewal
                  fees are paid.
                </p>
                <p className="text section__text _mb-13">
                  With reference to each domain name we register on your behalf,
                  you must comply with all the rules and policies from time to
                  time of the relevant registry or registration authority, and
                  you hereby agree to and must comply with any applicable domain
                  name registration agreement notified by us to you (including
                  any amendments notified to you).
                </p>
                <p className="text section__text _mb-13">
                  We shall not and shall have no obligation to offer or provide
                  any legal or other advice in relation to any actual or
                  potential domain name dispute.
                </p>
                <p className="text section__text _mb-23">
                  Subject to the first paragraph of Section 22, we shall have no
                  liability in respect of the suspension or loss of a domain
                  name as a result of any domain name arbitration procedure or
                  court proceedings.
                </p>
                <h5 className="title section__title _mb-17">
                  12. SSL/TLS certificates
                </h5>
                <p className="text section__text _mb-13">
                  We will make available SSL/TLS certificates for your domain
                  name. These certificates are provided by Let's Encrypt
                  (letsencrypt.org) and are free of charge.
                </p>
                <p className="text section__text _mb-13">
                  Domain names that you purchase all come with a free
                  certificate.
                </p>
                <p className="text section__text _mb-13">
                  Your Sites under a Siteplus subdomain (*.siteplus.com) will
                  benefit from a Siteplus wildcard SSL/TLS certificate.
                </p>
                <p className="text section__text _mb-23">
                  We do not supply extended validation certificates.
                </p>
                <h5 className="title section__title _mb-17">
                  13. Cooling-off period
                </h5>
                <p className="text section__text _mb-13">
                  This Section 13 applies if and only if you purchase a General
                  Subscription as a consumer - that is, as an individual acting
                  wholly or mainly outside your trade, business, craft or
                  profession. This Section 13 does not apply with respect to
                  Trial Subscriptions (which are free) or Reseller Subscriptions
                  (which are only available to business customers).
                </p>
                <p className="text section__text _mb-13">
                  Where this Section 13 applies, you may cancel a General
                  Subscription at any time before the end of the period 14 days
                  after the day on which the General Subscription begins. You do
                  not have to give any reason for your withdrawal or
                  cancellation.
                </p>
                <p className="text section__text _mb-13">
                  You agree that we may begin the provision of the General
                  Subscription before the expiry of the period referred to
                  above.
                </p>
                <p className="text section__text _mb-13">
                  In order to cancel a General Subscription on this basis, you
                  must inform us of your decision to cancel. You may inform us
                  by means of any clear statement setting out the decision. You
                  may inform us using the cancellation form found in your
                  Account Manager. To meet the cancellation deadline, it is
                  sufficient for you to send your communication concerning the
                  exercise of the right to cancel before the cancellation period
                  has expired.
                </p>
                <p className="text section__text _mb-13">
                  If you cancel a General Subscription on this basis, you will
                  receive a full refund of any amount you paid to us in respect
                  of the General Subscription.
                </p>
                <p className="text section__text _mb-13">
                  We will refund money using the same method used to make the
                  payment, unless you have expressly agreed otherwise. In any
                  case, you will not incur any fees as a result of the refund.
                </p>
                <p className="text section__text _mb-23">
                  We will process the refund due to you as a result of a
                  cancellation on this basis without undue delay and, in any
                  case, within the period of 14 days after the day on which we
                  are informed of the cancellation.
                </p>
                <h5 className="title section__title _mb-17">14. Resellers</h5>
                <p className="text section__text _mb-13">
                  To apply to become a reseller of the Services (a "
                  <strong className="text__strong">Reseller</strong>" with a "
                  <strong className="text__strong">
                    Reseller Subscription
                  </strong>
                  ") you must complete and submit our reseller application form.
                  Reseller Subscriptions are only available to business
                  customers, not consumers. We reserve the right to accept or
                  reject applications in our sole discretion.
                </p>
                <p className="text section__text _mb-13">
                  If you are a Reseller you will have access to our reseller
                  platform (the "
                  <strong className="text__strong">Reseller Platform</strong>
                  "), and using the Reseller Platform you may provide Trial
                  Subscriptions ("
                  <strong className="text__strong">
                    Reseller Customer Trial Subscriptions
                  </strong>
                  ") and free landing page / mini-site subscriptions ("
                  <strong className="text__strong">
                    Reseller Customer Landing Page Subscriptions
                  </strong>
                  "), and resell General Subscriptions, on a white label basis
                  to your own customers ("
                  <strong className="text__strong">Reseller Customers</strong>
                  "), allowing them to create websites ("
                  <strong className="text__strong">
                    Reseller Customer Sites
                  </strong>
                  ") notwithstanding the restrictions in Section 9.
                </p>
                <p className="text section__text _mb-13">
                  In these terms and conditions, Reseller Customers with access
                  to General Subscriptions shall be referred to as having as
                  having "
                  <strong className="text__strong">
                    Reseller Customer General Subscriptions
                  </strong>
                  ". Collectively, Reseller Customer Trial Subscriptions,
                  Reseller Customer Landing Page Subscriptions and Reseller
                  Customer General Subscriptions are termed "
                  <strong className="text__strong">
                    Reseller Customer Subscriptions
                  </strong>
                  ".
                </p>
                <p className="text section__text _mb-13">
                  You must only provide Reseller Customer Subscriptions under a
                  single brand name, as identified by you in the Customer
                  Manager. You must not, without our express written consent,
                  change the brand name under which you provide the Reseller
                  Customer Subscriptions during the period of your Reseller
                  Subscription.
                </p>
                <p className="text section__text _mb-13">
                  We may from time to time vary the benefits associated with a
                  Reseller Customer Trial Subscription or Reseller Customer
                  Landing Page Subscription in our sole discretion with or
                  without notice.
                </p>
                <p className="text section__text _mb-13">
                  All of these terms and conditions apply to Resellers, subject
                  to the modifications and additions set out in this Section 14.
                  In particular, references to "Your Sites" and "Your Data" in
                  these terms and conditions shall, with respect to Resellers,
                  include Reseller Customer Sites and the data stored in and
                  processed by the Reseller Customer Sites. We may cancel a
                  particular Reseller Customer Subscription, with or without
                  notice or explanation, if that Reseller Customer Subscription
                  is in breach of these terms and conditions.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that we do not host Reseller Customer Sites.
                  You will be responsible for your own hosting services for your
                  Reseller Customer Sites and for paying all the charges
                  associated with the hosting services.
                </p>
                <p className="text section__text _mb-13">
                  Resellers must ensure that each Reseller Customer enters into
                  a written contract with the Reseller relating to the creation
                  of the Reseller Customer Site, and that that written contract
                  includes restrictions and prohibitions on the use of the
                  Reseller Customer Subscription and the use of Images by the
                  Reseller Customer that are at least as comprehensive as those
                  set out in Section 9 and Section 17. Resellers must ensure
                  that we have the right to enforce those sections directly
                  against the Reseller Customers to the maximum extent
                  permissible under applicable law. Promptly following receipt
                  of a written request from us, Resellers must send to us copies
                  of such contractual terms.
                </p>
                <p className="text section__text _mb-13">
                  Each Reseller Customer Subscription shall, and Resellers must
                  ensure that each contract between the Reseller and a Reseller
                  Customer provides that the Reseller Customer Subscription
                  shall, automatically terminate upon the termination of the
                  Reseller Subscription.
                </p>
                <p className="text section__text _mb-13">
                  Our Reseller platform is designed as a white label managed
                  website builder services platform. You should apply your own
                  branding using the customer manager dashboard in your Account
                  (the "
                  <strong className="text__strong">Customer Manager</strong>
                  "), and in general Customers will encounter your branding when
                  using their Reseller Customer Subscriptions. You acknowledge,
                  however, that in some circumstances your Customers may
                  encounter Siteplus branding when using the Customer Reseller
                  Subscriptions. Notwithstanding this possibility, we will not
                  during the period of your Reseller Subscription actively and
                  deliberately seek to induce any current Reseller Customer of
                  yours to enter into a direct contract with us for the
                  provision of any of our services to that Reseller Customer.
                </p>
                <p className="text section__text _mb-13">
                  Resellers must not without our express written consent use any
                  of our trade marks (registered or unregistered) in connection
                  with the marketing, promotion, provision or resale of the
                  Reseller Customer Subscriptions.
                </p>
                <p className="text section__text _mb-13">
                  We will appoint a relationship manager for each Reseller.
                  Resellers must ensure that all communications with us relating
                  to the Services shall be made via the relationship manager
                  and/or the other reseller channels we provide.
                </p>
                <p className="text section__text _mb-13">
                  The Reseller is responsible for providing direct support to
                  Reseller Customers. In particular, you acknowledge that we
                  will not provide direct telephone support to Reseller
                  Customers.
                </p>
                <p className="text section__text _mb-13">
                  If you are a Reseller, you can download and use our plugins,
                  modules and extensions. The use of each plugin, module and
                  extension shall be subject to the end user licence agreement
                  that is supplied with the relevant plugin, module or
                  extension.
                </p>
                <p className="text section__text _mb-13">
                  We may make available to selected Resellers an API, to enable
                  those Resellers to interact with our software systems. With
                  respect to relevant Reseller Subscriptions, the API will
                  constitute an element of the Services, and its use is subject
                  to the acceptable use provisions in Section 17, along with the
                  other provisions of these terms and conditions.
                </p>
                <p className="text section__text _mb-13">
                  As a Reseller, you may cancel any Reseller Customer
                  Subscription at any time using the Customer Manager; Reseller
                  Customers may cancel their Reseller Customer Subscriptions
                  using their Account Managers. Such cancellations will take
                  effect upon and from the end of the then-current Reseller
                  Subscription period.
                </p>
                <p className="text section__text _mb-13">
                  You must notify us within immediately if you suspect or become
                  aware of any breach of security relating to the Customer
                  Manager.
                </p>
                <p className="text section__text _mb-23">
                  During the period of your Reseller Subscription, you must not
                  sell or resell any website builder product or service that
                  will or may compete with the Services, or enter into an
                  agreement or arrangement to do so. More generally, you must
                  not during the period of your Reseller Subscription be a party
                  to or enter into any agreement or arrangement that creates a
                  conflict of interest with your obligations under these terms
                  and conditions.
                </p>
                <h5 className="title section__title _mb-17">
                  15. Reseller fees
                </h5>
                <p className="text section__text _mb-13">
                  The fees payable by Resellers shall include an annual
                  membership fee for access to the Reseller Platform and
                  pay-as-you-go fees for each Reseller Customer General
                  Subscription.
                </p>
                <p className="text section__text _mb-13">
                  The applicable fees shall be as specified in your Customer
                  Manager on the Siteplus Site from time to time, save to the
                  extent that we agree otherwise in writing.
                </p>
                <p className="text section__text _mb-13">
                  Fees for access to the Reseller Platform must be paid in
                  advance through the Siteplus Site.
                </p>
                <p className="text section__text _mb-13">
                  Pay-as-you-go fees for the Reseller Customer Sites must be
                  paid monthly in arrears through the Siteplus Site, within 7
                  days following the end of the month to which they relate.
                </p>
                <p className="text section__text _mb-13">
                  You will be billed for all Services elements (including
                  Reseller Customer General Subscriptions and add-ons). For the
                  purpose of calculating fees, any Services element that was
                  active during any part of a month will be considered as active
                  for the entirety of that month.
                </p>
                <p className="text section__text _mb-23">
                  Resellers of at least 3 months standing may request that fees
                  be payable upon invoice. If we agree to such a request, we
                  will invoice for all fees monthly in arrears, and the Reseller
                  must pay all invoiced fees within 7 days following the date of
                  issue of the invoice.
                </p>
                <h5 className="title section__title _mb-17">16. Your data</h5>
                <p className="text section__text _mb-13">
                  Nothing in these terms and conditions shall operate to assign
                  or transfer any intellectual property rights from you to us,
                  or from us to you.
                </p>
                <p className="text section__text _mb-13">
                  You hereby grant to us a non-exclusive licence to copy,
                  reproduce, store, distribute, publish, export, adapt, edit and
                  translate Your Data to the extent reasonably required for the
                  performance of our obligations and the exercise of our rights
                  under these terms and conditions. You also grant to us the
                  right to sub-license these rights to our hosting, connectivity
                  and telecommunications service providers, subject to any
                  express restrictions elsewhere in these terms and conditions.
                </p>
                <p className="text section__text _mb-23">
                  You must ensure that Your Data complies with Section 17.
                  ‌Without prejudice to our other rights, if Your Data breaches
                  Section 17 in any way, or if we reasonably suspect that it
                  does, we may delete, unpublish or edit the relevant data.
                </p>
                <h5 className="title section__title _mb-17">
                  17. Acceptable use
                </h5>
                <p className="text section__text _mb-13">You must not:</p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    use the Siteplus Site or Services in any way or take any
                    action that causes, or may cause, damage to the website or
                    impairment of the performance, availability or accessibility
                    of the Siteplus Site or Services (including flooding the
                    Siteplus Site or Services with requests);
                  </li>
                  <li className="text list__item section__text _mb-7">
                    use the Siteplus Site or Services in any way that is
                    unlawful, illegal, fraudulent or harmful, or in connection
                    with any unlawful, illegal, fraudulent or harmful purpose or
                    activity;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    act in any way which may have a material negative effect
                    upon our registered and unregistered brands and trade marks,
                    including SITEPLUS;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    falsely claim to be us, or to represent us;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    use the Siteplus Site or Services to copy, store, host,
                    transmit, send, use, publish or distribute any material
                    which consists of (or is linked to) any spyware, computer
                    virus, Trojan horse, worm, keystroke logger, rootkit or
                    other malicious computer software;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    conduct any systematic or automated data collection
                    activities (including without limitation scraping, data
                    mining, data extraction and data harvesting) on or in
                    relation to the Siteplus Site or Services without our
                    express written consent;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    access or otherwise interact with the Siteplus Site or
                    Services using any robot, spider or other automated means,
                    except for the purpose of search engine indexing;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    violate the directives set out in the robots.txt file for
                    the Siteplus Site; or
                  </li>
                  <li className="text list__item section__text">
                    use data collected from the Siteplus Site or Services for
                    any direct marketing activity (including without limitation
                    email marketing, SMS marketing, telemarketing and direct
                    mailing).
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  You must ensure that all the information you supply to us
                  through the Siteplus Site, or in relation to the Services, is
                  true, accurate, current, complete and non-misleading.
                </p>
                <p className="text section__text _mb-13">
                  You must ensure that Your Data will not infringe the
                  intellectual property rights or other legal rights of any
                  person, and will not breach the provisions of any law, statute
                  or regulation, in any jurisdiction and under any applicable
                  law.
                </p>
                <p className="text section__text _mb-13">
                  Without prejudice to the generality of the preceding
                  paragraph, Your Data, and the use of Your Data by us in any
                  manner licensed or otherwise authorised by you, must not:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    be libellous or maliciously false;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    be obscene or indecent;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    infringe any copyright, moral right, database right, trade
                    mark right, design right, right in passing off, or other
                    intellectual property right;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    infringe any right of confidence, right of privacy or right
                    under data protection legislation;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    constitute negligent advice or contain any negligent
                    statement;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    constitute an incitement to commit a crime, instructions for
                    the commission of a crime or the promotion of criminal
                    activity;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    be in contempt of any court, or in breach of any court
                    order;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    constitute a breach of racial or religious hatred or
                    discrimination legislation;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    be blasphemous;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    constitute a breach of official secrets legislation; or
                  </li>
                  <li className="text list__item section__text">
                    constitute a breach of any contractual obligation owed to
                    any person.
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  You must ensure that Your Data is not and has never been the
                  subject of any threatened or actual legal proceedings or other
                  similar complaint.
                </p>
                <p className="text section__text _mb-13">
                  Your Data must be appropriate for all persons who have access
                  to or are likely to access Your Data in question. Your Data
                  must not depict violence in an explicit, graphic or gratuitous
                  manner. Your Data must not be pornographic or sexually
                  explicit.
                </p>
                <p className="text section__text _mb-13">
                  Your Data must not constitute or contain spam, and you must
                  not use the Services to store or transmit spam - which for
                  these purposes shall include all unlawful marketing
                  communications and unsolicited commercial communications.
                </p>
                <p className="text section__text _mb-13">
                  You must not use the Services to promote, host or operate any
                  chain letters, Ponzi schemes, pyramid schemes, matrix
                  programs, multi-level marketing schemes, "get rich quick"
                  schemes or similar letters, schemes or programs.
                </p>
                <p className="text section__text _mb-13">
                  You must not use the Services in any way which is liable to
                  result in the blacklisting of any of our IP addresses.
                </p>
                <p className="text section__text _mb-13">
                  You must not use the Services for any purpose relating to:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    any illegal or unlawful activity;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    gambling, regulated gaming, betting, lotteries, sweepstakes,
                    prize competitions or any gambling-related activity;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    the promotion, hosting or operation of any chain letters,
                    Ponzi schemes, pyramid schemes, matrix programs, multi-level
                    marketing schemes, "get rich quick" schemes or similar
                    letters, schemes or programs;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    prostitution or sexual services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    the offering for sale, sale or distribution of any
                    pornographic material;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    the offering for sale, sale or distribution of drugs or
                    pharmaceuticals; or
                  </li>
                  <li className="text list__item section__text">
                    the offering for sale, sale or distribution of knives, guns
                    or other weapons.
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  Your Data must not contain or consist of, and you must not
                  promote, distribute or execute by means of the Services, any
                  viruses, worms, spyware, adware or other harmful or malicious
                  software, programs, routines, applications or technologies.
                </p>
                <p className="text section__text _mb-13">
                  Your Data must not contain or consist of, and you must not
                  promote, distribute or execute by means of the Services, any
                  software, programs, routines, applications or technologies
                  that will or may have a material negative effect upon the
                  performance of a computer or introduce material security risks
                  to a computer.
                </p>
                <p className="text section__text _mb-23">
                  If you learn of any unlawful material or activity on the
                  Siteplus Site or in our network or systems, or any material or
                  activity that breaches these terms and conditions, please let
                  us know. You can let us know about any such material or
                  activity by email or using our abuse reporting form. See
                  Section 23 for information about the actions we may take in
                  the event of a breach of these terms and conditions.
                </p>
                <h5 className="title section__title _mb-17">
                  18. Personal data
                </h5>
                <p className="text section__text _mb-13">
                  This Section 18 applies in relation to personal data that we
                  process on your behalf.
                </p>
                <p className="text section__text _mb-13">
                  It does not apply in relation to personal data with respect to
                  which we are a controller, such as our customer relationship
                  data; nor, if you are an individual, does it apply with
                  respect to your own personal data. See our privacy and cookies
                  policy for information about how we handle personal data with
                  respect to which we are a controller.
                </p>
                <p className="text section__text _mb-13">
                  Save where we act as a controller, you shall only supply to
                  us, and we shall only process: (a) the personal data of users
                  of Your Sites; and (b) personal data of the types that you
                  specify as collectable when configuring Your Sites.
                </p>
                <p className="text section__text _mb-13">
                  We shall only process your personal data for the purposes of
                  providing and monitoring the Services.
                </p>
                <p className="text section__text _mb-13">
                  We shall only process the personal data during the term of a
                  contract under these terms and conditions and for not more
                  than 30 days following the end of that term, subject to the
                  other provisions of this Section 18.
                </p>
                <p className="text section__text _mb-13">
                  We shall only process the personal data on your documented
                  instructions (including with regard to transfers of the
                  personal data to any place outside the European Economic
                  Area), as set out in these terms and conditions or any other
                  document agreed by you and us in writing. You hereby authorise
                  those transfers specified on the Siteplus Site.
                </p>
                <p className="text section__text _mb-13">
                  Notwithstanding any other provision of these terms and
                  conditions, we may process the personal data if and to the
                  extent that we are required to do so by applicable law. In
                  such a case, we shall inform you of the legal requirement
                  before processing, unless that law prohibits such information
                  on important grounds of public interest.
                </p>
                <p className="text section__text _mb-13">
                  We shall ensure that persons authorised to process the
                  personal data have committed themselves to confidentiality or
                  are under an appropriate statutory obligation of
                  confidentiality.
                </p>
                <p className="text section__text _mb-13">
                  We and you shall each implement appropriate technical and
                  organisational measures to ensure an appropriate level of
                  security for the personal data.
                </p>
                <p className="text section__text _mb-13">
                  We will not engage any third party to process the personal
                  data without your prior specific or general written
                  authorisation. In the case of a general written authorisation,
                  we shall inform you at least 14 days in advance of any
                  intended changes concerning the addition or replacement of any
                  third party processor, and if you object to any such changes
                  before their implementation, then you may terminate the
                  contract under these terms and conditions on 7 days' written
                  notice to us, providing that such notice must be given within
                  the period of 7 days following the date that we informed you
                  of the intended changes. We shall ensure that each third party
                  processor is subject to the equivalent legal obligations as
                  those imposed on us by this Section 18.
                </p>
                <p className="text section__text _mb-13">
                  You hereby authorise us to engage, as sub-processors with
                  respect to the personal data, third parties providing services
                  within the following categories: (a) hosting, back-up,
                  security and content delivery services; (b) communications
                  services; and (c) support services infrastructure.
                </p>
                <p className="text section__text _mb-13">
                  We shall, insofar as possible and taking into account the
                  nature of the processing, take appropriate technical and
                  organisational measures to assist you with the fulfilment of
                  your obligation to respond to requests exercising a data
                  subject's rights under applicable data protection laws.
                </p>
                <p className="text section__text _mb-13">
                  We shall assist you in ensuring compliance with the
                  obligations relating to the security of processing of personal
                  data, the notification of personal data breaches to the
                  supervisory authority, the communication of personal data
                  breaches to the data subject, data protection impact
                  assessments and prior consultation in relation to high-risk
                  processing under applicable data protection laws.
                </p>
                <p className="text section__text _mb-13">
                  We shall notify you of any personal data breach affecting your
                  personal data without undue delay and, in any case, not later
                  than 72 hours after we become aware of the breach.
                </p>
                <p className="text section__text _mb-13">
                  We shall make available to you all information necessary to
                  demonstrate our compliance with our obligations under this
                  Section 18 and applicable data protection laws.
                </p>
                <p className="text section__text _mb-13">
                  We shall, at your choice, delete or return all of the personal
                  data to you after the provision of services relating to the
                  processing, and shall delete existing copies save to the
                  extent that applicable law requires storage of the relevant
                  personal data.
                </p>
                <p className="text section__text _mb-13">
                  We shall allow for and contribute to audits, including
                  inspections, conducted by you or another auditor mandated by
                  you in respect of the compliance of our processing of the
                  personal data with applicable data protection laws and this
                  Section 18.
                </p>
                <p className="text section__text _mb-23">
                  We may charge you at our standard time-based charging rates
                  for any work performed by us at your request pursuant to this
                  Section 18.
                </p>
                <h5 className="title section__title _mb-17">
                  19. Third Party Services
                </h5>
                <p className="text section__text _mb-13">
                  The Services are integrated with those third party social
                  media, cloud storage, analytics, ecommerce and other services
                  (the "
                  <strong className="text__strong">Third Party Services</strong>
                  ") identified on the Siteplus Site from time to time. We may
                  integrate additional Third Party Services with the Services at
                  any time, and we may remove, suspend or limit any Third Party
                  Services integration at any time in our sole discretion.
                </p>
                <p className="text section__text _mb-13">
                  The supply of Third Party Services shall be under a separate
                  contract or arrangement between you and the relevant third
                  party. You are responsible for ensuring that you comply with
                  the terms and conditions of such contracts and arrangements.
                  You acknowledge that: (a) the integration of Third Party
                  Services may entail the transfer of Your Data from the
                  Services to the relevant Third Party Services, and the
                  transfer of data from the relevant Third Party Services to our
                  Services; and (b) we have no control over, or responsibility
                  in respect of, any disclosure, modification, deletion or other
                  use of Your Data resulting from any integration with any Third
                  Party Services.
                </p>
                <p className="text section__text _mb-23">
                  Without prejudice to your other obligations under this Section
                  19, you must ensure that you have in place the necessary
                  contractual safeguards to ensure that both the transfer of
                  relevant personal data to a provider of Third Party Services
                  and its use by that provider are lawful.
                </p>
                <h5 className="title section__title _mb-17">
                  20. Limited warranties and acknowledgements
                </h5>
                <p className="text section__text _mb-13">
                  We do not warrant or represent: (a) the completeness or
                  accuracy of the information published on the Siteplus Site or
                  available through the Services; (b) that the material on the
                  Siteplus Site or available through the Services is up to date;
                  or (c) that the Siteplus Site and Services will remain
                  available in future.
                </p>
                <p className="text section__text _mb-13">
                  We reserve the right to discontinue or alter any or all of the
                  Services, and to stop publishing the Siteplus Site, at any
                  time in our sole discretion without notice or explanation; and
                  save to the extent expressly provided otherwise in these terms
                  and conditions, you will not be entitled to any compensation
                  or other payment upon the discontinuance or alteration of the
                  Services.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that complex software is never wholly free
                  from defects, errors and bugs; and subject to the other
                  provisions of these terms and conditions, we give no warranty
                  or representation that the Services will be wholly free from
                  defects, errors and bugs.‌
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that complex software is never entirely free
                  from security vulnerabilities; and subject to the other
                  provisions of these terms and conditions, we give no warranty
                  or representation that the Services will be entirely secure.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that the Services support most desktop web
                  browsers for viewing and editing a website, and Chrome and
                  Safari browsers for viewing sites on mobile devices. We focus
                  our support on the most recent versions of most major
                  browsers.
                </p>
                <p className="text section__text _mb-13">
                  A list of compatible browsers can be found on the Siteplus
                  Site.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that we will not provide any legal, financial,
                  accountancy or taxation advice under these terms and
                  conditions or in relation to the Services; and, except to the
                  extent expressly provided otherwise in these terms and
                  conditions, we do not warrant or represent that the Services
                  or your use of the Services will not give rise to any legal
                  liability on your part or any other person.
                </p>
                <p className="text section__text _mb-13">
                  The Services enable you to convert an existing website and
                  import the website into the Services infrastructure. You
                  acknowledge that you may be unable to transfer some
                  functionality, design features and/or content from the
                  existing website to Your Sites, and that some functionality,
                  design features and/or content may be modified or transformed
                  during the conversion process. We do not warrant or represent
                  that you will be able to convert any particular functionality,
                  design features or content.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that we are not responsible for any changes in
                  web traffic or search engine results page rankings that may
                  result from the conversion of an existing website, and that
                  you are responsible and bear all risks associated with any
                  such conversion.‌
                </p>
                <p className="text section__text _mb-13">
                  Although we will take back-ups copies of our database from
                  time to time, these are for our own use only. You should make
                  and keep back-up copies of all data that you store or process
                  using the Services.
                </p>
                <p className="text section__text _mb-13">
                  You acknowledge that we are not party to any contract for the
                  sale or purchase of products or services entered into through
                  Your Sites, and that we are not involved in any other
                  transactions that you may enter into through Your Sites; and
                  accordingly we will not be liable to any person in relation to
                  the offer for sale or sale or purchase of any products or
                  services through Your Sites.
                </p>
                <p className="text section__text _mb-23">
                  To the maximum extent permitted by applicable law and subject
                  to the first paragraph of Section 22, we exclude all
                  representations and warranties not expressly set out in these
                  terms and conditions relating to the subject matter of these
                  terms and conditions.
                </p>
                <h5 className="title section__title _mb-17">
                  21. Indemnification
                </h5>
                <p className="text section__text _mb-23">
                  You hereby indemnify us, and undertake to keep us indemnified,
                  against any and all losses, damages, costs, liabilities and
                  expenses (including without limitation legal expenses and any
                  amounts paid by us to a third party in settlement of a claim
                  or dispute) incurred or suffered by us and arising directly or
                  indirectly out of: (a) your use of the Siteplus Site or
                  Services; (b) any breach by you of any provision of these
                  terms and conditions; or (c) if you are a Reseller, any act or
                  omission of any of your Reseller Customers.
                </p>
                <h5 className="title section__title _mb-17">
                  22. Limitation of liability
                </h5>
                <p className="text section__text _mb-13">
                  Nothing in these terms and conditions will: (a) limit or
                  exclude any liability for death or personal injury resulting
                  from negligence; (b) limit or exclude any liability for fraud
                  or fraudulent misrepresentation; (c) limit any liabilities in
                  any way that is not permitted under applicable law; or (d)
                  exclude any liabilities that may not be excluded under
                  applicable law – and, if you are a consumer, your statutory
                  rights will not be excluded or limited by these terms and
                  conditions, except to the extent permitted by law.
                </p>
                <p className="text section__text _mb-13">
                  The limitations and exclusions of liability set out in these
                  terms and conditions are subject to the paragraph above, and
                  govern all liabilities arising under these terms and
                  conditions or relating to the subject matter of these terms
                  and conditions, including liabilities arising in contract, in
                  tort (including negligence) and for breach of statutory duty,
                  except to the extent expressly provided otherwise in these
                  terms and conditions.
                </p>
                <p className="text section__text _mb-13">
                  To the extent that the Siteplus Site and the information and
                  services on the Siteplus Site are provided free of charge, we
                  will not be liable for any loss or damage of any nature.
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any losses arising
                  out of any event or events beyond our reasonable control. If
                  any event beyond our reasonable control gives rise to a
                  failure or delay in us performing any obligation under these
                  terms and conditions (other than any obligation to make a
                  payment), the obligation will be suspended for the duration of
                  that event.
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any business
                  losses, including (without limitation) loss of or damage to
                  profits, income, revenue, use, production, anticipated
                  savings, business, contracts, commercial opportunities or
                  goodwill. We will not be liable to you in respect of any loss
                  or corruption of any data, database or software.
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any data loss or
                  other losses caused by your failure to keep back-up copies of
                  your data in accordance with Section 20; nor will we be liable
                  for any data loss or other losses arising out of the archiving
                  or deletion of data following the termination of a
                  Subscription.
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any special,
                  indirect or consequential loss or damage.
                </p>
                <p className="text section__text _mb-13">
                  You accept that we have an interest in limiting the personal
                  liability of our officers and employees and, having regard to
                  that interest, you acknowledge that we are a limited liability
                  entity; you agree that you will not bring any claim personally
                  against our officers or employees in respect of any losses you
                  suffer in connection with the website or these terms and
                  conditions (this will not, of course, limit or exclude the
                  liability of the limited liability entity itself for the acts
                  and omissions of our officers and employees).
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any loss or damage
                  arising out of the unavailability of the Services, to the
                  extent that such unavailability is caused by a third party
                  services provider engaged by us.
                </p>
                <p className="text section__text _mb-13">
                  We will not be liable to you in respect of any loss or damage
                  arising out of your use of the Images outside the scope of the
                  licence granted under these terms and conditions.
                </p>
                <p className="text section__text _mb-23">
                  Our aggregate liability to you in respect of any contract to
                  provide services to you under these terms and conditions shall
                  not exceed the greater of: (a) USD 100; and (b) the total
                  amount paid and payable to us under the contract.
                </p>
                <h5 className="title section__title _mb-17">
                  23. Breaches of these terms and conditions
                </h5>
                <p className="text section__text _mb-13">
                  Without prejudice to our other rights under these terms and
                  conditions, if you breach these terms and conditions in any
                  way, or if we reasonably suspect that you have breached these
                  terms and conditions in any way, we may:
                </p>
                <ul className="list list_disc _mb-13">
                  <li className="text list__item section__text _mb-7">
                    send you one or more formal warnings;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    temporarily suspend your access to the Siteplus Site and/or
                    Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    permanently prohibit you from accessing the Siteplus Site
                    and/or Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    block computers using your IP address from accessing the
                    Siteplus Site and/or Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    contact any or all of your internet service providers and
                    request that they block your access to the Siteplus Site
                    and/or Services;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    commence legal action against you, whether for breach of
                    contract or otherwise; and/or
                  </li>
                  <li className="text list__item section__text">
                    suspend or delete your Account.
                  </li>
                </ul>
                <p className="text section__text _mb-13">
                  Where we suspend or prohibit or block your access to the
                  Siteplus Site or a part of the Siteplus Site, you must not
                  take any action to circumvent such suspension or prohibition
                  or blocking (including without limitation creating and/or
                  using a different account).
                </p>
                <p className="text section__text _mb-23">
                  We may cancel your Trial Subscription, General Subscription or
                  Reseller Subscription immediately by giving to you written
                  notice of cancellation if: (a) you breach any provision of
                  these terms and conditions, or fail to pay to us on time and
                  in full any amount you owe to us; or (b) you are insolvent or
                  bankrupt, or are the subject of any bankruptcy or insolvency
                  process or proceedings.
                </p>
                <h5 className="title section__title _mb-13">
                  24. Cancellation
                </h5>
                <h6 className="title section__title _mb-13 section__second-title">
                  Cancellation of Trial Subscriptions
                </h6>
                <p className="text section__text _mb-13">
                  We may cancel a Trial Subscription at any time by giving to
                  you written notice of cancellation.
                </p>
                <p className="text section__text _mb-13">
                  If you do not upgrade to a General Subscription at the end of
                  the Trial Subscription period, then your Subscription will be
                  automatically cancelled.
                </p>
                <h6 className="title section__title _mb-13 section__second-title">
                  Cancellation of General Subscriptions
                </h6>
                <p className="text section__text _mb-13">
                  You may cancel a General Subscription at any time using your
                  Account Manager; similarly, we may cancel a General
                  Subscription at any time by giving to you written notice of
                  cancellation. Such cancellation will take effect upon and from
                  the end of the current General Subscription period as at the
                  date we issue or receive the notice (as the case may be).
                </p>
                <p className="text section__text _mb-13">
                  If you do not pay the fees for your General Subscription by
                  the due date, then the General Subscription may be
                  automatically cancelled.
                </p>
                <h6 className="title section__title _mb-13 section__second-title">
                  Cancellation of Reseller Subscriptions
                </h6>
                <p className="text section__text _mb-13">
                  You may cancel a Reseller Subscription at any time using your
                  Account Manager; similarly, we may cancel a Reseller
                  Subscription at any time by giving to you written notice of
                  cancellation. Such cancellation will take effect upon and from
                  the end of the current Reseller Subscription period as at the
                  date we issue or receive the notice (as the case may be).
                </p>
                <p className="text section__text _mb-13">
                  If you do not pay the fees for your Reseller Subscription or
                  your pay-as-you-go fees by the due date, then the Reseller
                  Subscription may be automatically cancelled.
                </p>
                <p className="text section__text _mb-13">
                  If your Reseller Subscription is cancelled, then we will have
                  the right (but not the obligation) at any time to: (a)
                  communicate directly with your Reseller Customers; and (b)
                  with the agreement of the relevant Reseller Customer, convert
                  Reseller Customer Trial Subscriptions to Trial Subscriptions,
                  and convert Reseller Customer General Subscriptions to General
                  Subscriptions.
                </p>
                <h6 className="title section__title _mb-13 section__second-title">
                  Cancellation of inactive Accounts
                </h6>
                <p className="text section__text _mb-23">
                  We may cancel any Account that does not have an active
                  associated General Subscription or Reseller Subscription, at
                  any time in our sole discretion.
                </p>
                <h5 className="title section__title _mb-17">
                  25. Effects of cancellation of Subscriptions
                </h5>
                <p className="text section__text _mb-13">
                  Upon or following the cancellation of any Subscription, Your
                  Sites that were published under that Subscription will be
                  unpublished. Subject to the other provisions of these terms
                  and conditions: (a) upon and from the effective date of
                  cancellation of any Subscription, you will not be able to make
                  any changes to Your Sites; and (b) at any time after the
                  period of 7 days following the effective date of cancellation,
                  Your Sites and the associated Account will be archived, and
                  there will be no way for you to access Your Sites after such
                  archiving. Your Sites and Your Data will be deleted from our
                  back-up systems before the 30th day following deletion from
                  our live systems.
                </p>
                <p className="text section__text _mb-13">
                  The provisions of the preceding paragraph shall also apply if
                  you are a Reseller, in which case your Reseller Customer Sites
                  will be unpublished and you will not be able to make changes
                  to Reseller Customer Sites after the specified period; nor
                  will you be able to access Reseller Customer Sites or
                  associated data after archiving.
                </p>
                <p className="text section__text _mb-13">
                  The cancellation of a Subscription shall not affect your or
                  our accrued rights.
                </p>
                <p className="text section__text _mb-13">
                  You will not be entitled to any refund if your Account and/or
                  Subscription is cancelled in accordance with these terms and
                  conditions.
                </p>
                <p className="text section__text _mb-23">
                  Within 7 days following the cancellation of your Subscription
                  for any reason, you must pay to us any amounts due with
                  respect to the Services provided before the date of
                  cancellation, without prejudice to our other legal rights.
                </p>
                <h5 className="title section__title _mb-17">
                  26. Third party websites
                </h5>
                <p className="text section__text _mb-23">
                  Our website includes hyperlinks to other websites owned and
                  operated by third parties; such hyperlinks are not
                  recommendations. We have no control over third party websites
                  and their contents, and subject to the first paragraph of
                  Section 22, we accept no responsibility for them or for any
                  loss or damage that may arise from your use of them.
                </p>
                <h5 className="title section__title _mb-17">27. Trade marks</h5>
                <p className="text section__text _mb-13">
                  SITEPLUS, our logos and our other registered and unregistered
                  trade marks are trade marks belonging to us; we give no
                  permission for the use of these trade marks, and such use may
                  constitute an infringement of our rights.
                </p>
                <p className="text section__text _mb-23">
                  The third party registered and unregistered trade marks or
                  service marks on the Siteplus Site are the property of their
                  respective owners and, unless stated otherwise in these terms
                  and conditions, we do not endorse and are not affiliated with
                  any of the holders of any such rights and as such we cannot
                  grant any licence to exercise such rights.
                </p>
                <h5 className="title section__title _mb-17">
                  28. Miscellaneous
                </h5>
                <p className="text section__text _mb-13">
                  Any notice from one party to the other party under these terms
                  and conditions must be sent by email to the relevant email
                  address specified: (a) in the case of notices to you, in your
                  Account details; and (b) in the case of notices to us, in
                  Section 30, and the notice shall be deemed to be received upon
                  receipt of the email by the recipient's email server.
                </p>
                <p className="text section__text _mb-13">
                  We may revise these terms and conditions from time to time.
                  The revised terms and conditions shall apply to the use of the
                  Siteplus Site from the date of publication of the revised
                  terms and conditions on the website, and you hereby waive any
                  right you may otherwise have to be notified of, or to consent
                  to, revisions of these terms and conditions. If you object to
                  any changes to the terms and conditions, then your only remedy
                  is to terminate your Subscription.
                </p>
                <p className="text section__text _mb-13">
                  You hereby agree that we may assign, transfer, sub-contract or
                  otherwise deal with our rights and/or obligations under these
                  terms and conditions - providing, if you are a consumer, that
                  such action does not serve to reduce the guarantees benefiting
                  you under these terms and conditions. You may not without our
                  prior written consent assign, transfer, sub-contract or
                  otherwise deal with any of your rights and/or obligations
                  under these terms and conditions.
                </p>
                <p className="text section__text _mb-13">
                  If a provision of these terms and conditions is determined by
                  any court or other competent authority to be unlawful and/or
                  unenforceable, the other provisions will continue in effect.
                  If any unlawful and/or unenforceable provision of these terms
                  and conditions would be lawful or enforceable if part of it
                  were deleted, that part will be deemed to be deleted, and the
                  rest of the provision will continue in effect.{' '}
                </p>
                <p className="text section__text _mb-13">
                  A contract under these terms and conditions is for our benefit
                  and your benefit and is not intended to benefit or be
                  enforceable by any third party. The exercise of the parties'
                  rights under a contract under these terms and conditions is
                  not subject to the consent of any third party.
                </p>
                <p className="text section__text _mb-13">
                  Subject to the first paragraph of Section 22, these terms and
                  conditions shall constitute the entire agreement between you
                  and us in relation to the subject matter hereof, and shall
                  supersede all previous agreements between you and us in
                  relation to that subject matter.
                </p>
                <p className="text section__text _mb-13">
                  These terms and conditions shall be governed by and construed
                  in accordance with Singapore law. Any disputes relating to
                  these terms and conditions shall be subject to the exclusive
                  jurisdiction of the courts of Singapore.
                </p>
                <p className="text section__text _mb-23">
                  For the avoidance of doubt, references to giving "written
                  notice" in these terms and conditions include giving the
                  notice by email.
                </p>
                <h5 className="title section__title _mb-17">
                  29. Statutory information
                </h5>
                <p className="text section__text _mb-13">
                  We will not file a copy of these terms and conditions
                  specifically in relation to each user or customer, and if we
                  update these terms and conditions, the version to which you
                  originally agreed will no longer be available on the Siteplus
                  Site. We recommend that you consider saving a copy of these
                  terms and conditions for future reference.
                </p>
                <p className="text section__text _mb-23">
                  These terms and conditions are available in the English
                  language only.
                </p>
                <h5 className="title section__title _mb-17">
                  30. Contacting us
                </h5>
                <p className="text section__text _mb-13">
                  This website is owned and operated by Siteplus Pte Ltd.
                </p>
                <p className="text section__text _mb-13">
                  We are registered in Singapore under registration number
                  201614837Z, and our registered office is at 10 Anson Road,
                  #22-02, International Plaza, Singapore 079903.
                </p>
                <p className="text section__text _mb-13">You can contact us:</p>
                <ul className="list list_disc">
                  <li className="text list__item section__text _mb-7">
                    by post, using the postal address given above;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    using the Siteplus Site contact form;
                  </li>
                  <li className="text list__item section__text _mb-7">
                    by telephone, on the contact number published on the
                    Siteplus Site from time to time; or
                  </li>
                  <li className="text list__item section__text">
                    by email, using the email address published on the Siteplus
                    Site from time to time.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Terms;
